import { Component } from '../../../libs/gin-tonic/helpers/compiler';

declare let TweenMax: any;

@Component({ className: 'js-clock' })
export class ClockComponent {
	private digits;

	constructor(private element: HTMLElement) {
		this.digits = this.element.querySelectorAll('.js-digit');
	}

	public updateTimerDisplay = (newVal: string) => {
		const arr = newVal.split('');

		this.digits.forEach((digit, i) => {
			TweenMax.killTweensOf(digit);
			TweenMax.to(digit, 1, {
				y: - digit.querySelector('.js-digit-' + arr[i]).offsetTop
			});
		})
	}
}
